<template>
  <div id="buyOrderPrint">
    <div
      v-for="(ele,idx) in sliceDataList"
      :key="idx"
      :class="idx+1 !== sliceDataList.length ? 'break_after' : ''"
      style="padding:0.5cm"
    >
      <div class="title" style="font-size:1.2cm">厦门力元工贸有限公司</div>
      <div class="title" style="font-size:0.7cm;margin-top:0.1cm">Xiamen Liyuan Co., Ltd</div>
      <div style="display:flex;justify-content:space-between">
        <div>电话:0592-6381198</div>
        <div>传真:0592-6381197</div>
        <div>邮编:361023</div>
      </div>
      <div style="display:flex;justify-content:space-between">
        <div>地址:厦门市集美后溪工业区白虎岩路33号</div>
        <div>E-mail:xmliyuan@163.com</div>
      </div>
      <hr style="border:0.03cm solid #000000;margin:0.1cm 0" />
      <div style="text-align: center;line-height:1.5cm;font-size:1cm;margin-bottom:0.2cm">订 货 单</div>
      <table class="firstTable">
        <tr>
          <td>厂商名称</td>
          <td>{{info.supplier}}</td>
          <td>订货单号</td>
          <td>{{info.buy_number}}</td>
        </tr>
      </table>
      <table class="secondTable" style="margin-top:-1px">
        <tr>
          <td>序号</td>
          <td>材质</td>
          <td>规格</td>
          <!-- <td>单位</td> -->
          <td>重量</td>
          <td>单价</td>
          <td>交期</td>
          <td>品名</td>
          <td>备注</td>
        </tr>
        <tr v-for="index in 10" :key="index">
          <!-- <tr v-for="(item,index) in ele" :key="index"> -->
          <td>{{index}}</td>
          <td v-if="ele[index-1] !== undefined">{{ele[index-1].material_name}}</td>
          <td v-else></td>
          <td v-if="ele[index-1] !== undefined">
            <span v-for="(sizeNumber,idx) in ele[index-1].material_size.split('*')" :key="idx">
              <span v-if="sizeNumber!==''">
                <span
                  v-if="sizeNumber.indexOf('/')===-1"
                  style="display:inline-block"
                >{{sizeNumber.replace('@','↧').replace('^','φ')}}</span>
                <span style="display:inline-block" v-else>
                  <span
                    style="display:inline-block;text-align:right"
                  >{{sizeNumber.split(/[+|-]/)[0].replace('@','↧').replace('^','φ')}}</span>
                  <span style="position:relative;width:37px;display:inline-block">
                    <sup
                      style="position:absolute;left:0px;bottom:5px;width:40px;display:inline-block;line-height:10px;text-align:left"
                    >{{sizeNumber.match(/[+|-]/)[0]+sizeNumber.split(/[+|-]/)[1].split('/')[0]}}</sup>
                    <sub
                      style="position:absolute;left:2px;top:-5px;width:40px;display:inline-block;line-height:10px;text-align:left"
                    >{{sizeNumber.match(/\/(.)/)[1]+sizeNumber.split(/[+|-]/)[2]}}</sub>
                  </span>
                </span>
                <span v-if="idx+1 !== ele[index-1].material_size.split('*').length">*</span>
              </span>
            </span>
          </td>
          <td v-else></td>
          <!-- <td v-if="ele[index-1] !== undefined">kg</td>
          <td v-else></td>-->
          <td v-if="ele[index-1] !== undefined">{{ele[index-1].buy_count}}</td>
          <td v-else></td>
          <td v-if="ele[index-1] !== undefined">{{ele[index-1].buy_price}}</td>
          <td v-else></td>
          <td
            v-if="ele[index-1] !== undefined"
          >{{ele[index-1].deliver_date ? new Date(new Date(ele[index-1].deliver_date).getTime() - 864000000).format('yyyy-MM-dd') : ''}}</td>
          <td v-else></td>
          <td v-if="ele[index-1] !== undefined && ele[index-1].product_name !== null"><span style="font-size:12px;transform:scale(.7)">{{`${ele[index-1].customer_name}:${ele[index-1].product_name}(${ele[index-1].product_size})`}}</span></td>
          <td v-else></td>
          <td v-if="ele[index-1] !== undefined"><span style="font-size:12px;transform:scale(.7)">{{ele[index-1].remark}}</span></td>
          <td v-else></td>
        </tr>
      </table>
      <table style="margin-top:-1px">
        <tr>
          <td>其他要求</td>
          <td style="text-align:left">
            <div>1.供应商必须按我方质量标准要求供货，传真件与原件具有同等效律。</div>
            <div>2.交货地点：厦门市集美后溪工业区白虎岩路33号力元工贸有限公司；运费由供方承担。</div>
            <div>3.结算方式:</div>
            <div>4.供应商需按照我方之要求保质、保量，按时交货，若由于产品质量问题、交期、数量等原因而产生之后果由供方承担。</div>
            <div>5.未尽事宜按照合同法与国家颁布的有关经济法规处理，因合同发生的争议，双方应友好协商解决。协商未果，由需方所在地仲裁委员会仲裁。</div>
          </td>
        </tr>
        <tr>
          <td>签核</td>
          <td style="text-align:left">
            <div>
              <span style="display:inline-block;width:10cm">供应商全称:</span>厦门力元金属科技有限公司
            </div>
            <div>
              <span style="display:inline-block;width:10cm">地址:</span>
              <span style="display:inline-block;width:5cm">订购人:</span>
            </div>
            <div>
              <span style="display:inline-block;width:10cm">电话:</span>
              <span style="display:inline-block;width:5cm">核准:</span>
            </div>
            <div>传真:</div>
            <div>法定代表人或委托代理人:</div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { sliceArray } from '../assets/lib/utils'
export default {
  data () {
    return {
      info: JSON.parse(this.$route.query.info),
      sliceDataList: []
    }
  },
  mounted () {
    this.sliceDataList = sliceArray(this.info.materialList, 10)
    setTimeout(() => {
      window.print()
    }, 500)
  },
  methods: {
  }
}
</script>

<style>
#buyOrderPrint .title {
  text-align: center;
  line-height: 0.8cm;
}
#buyOrderPrint table,
#buyOrderPrint table tr th,
#buyOrderPrint table tr td {
  border: 1px solid #000000;
}
#buyOrderPrint table {
  text-align: center;
  border-collapse: collapse;
  width: 100%;
  line-height: 0.9cm;
}
#buyOrderPrint .firstTable td:nth-child(1),
#buyOrderPrint .firstTable td:nth-child(3) {
  width: 3cm;
}
.break_after {
  page-break-after: always;
}
@page :pseudo-class {
  size: A4;
}
</style>
